module.exports = __webpack_public_path__ + "static/media/reference-slider-25.a37f7ae0.jpg";